import { toast } from "react-toastify";

// Get logged in user safely
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (!user) return null;

  try {
    return JSON.parse(user);
  } catch (error) {
    console.error("Error parsing user data:", error);
    return null;
  }
};

// Logout function
export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");

  toast.success("Logged out successfully!");

  setTimeout(() => {
    window.location.href = "/sign-in";
  }, 500);
};
